/**
 * The vendor's name on every screen, notice, e-mail and error text (Phase 13f-2, D-134; CLAUDE.md "Arayüz
 * adları"), never "Dbrain": kept here only, so it can change. Both languages use these values (the web's i18n has
 * them as default variables `vendor` and `vendorTo`). A Turkish text needs the name at most with the dative
 * ending ("…'e gönderin"); its sentences are written so that no other ending is needed. Change both together.
 */
export const VENDOR = {
  name: 'Digital Brain Technologies',
  nameDativeTr: "Digital Brain Technologies'e",
} as const;
